module.exports = __webpack_public_path__ + "static/banner-empresa-b5f591801761a348cdd3a8be02456a36.jpg";